import { render, staticRenderFns } from "./section-blood-oxygen.vue?vue&type=template&id=6dfbeb53&scoped=true"
import script from "./section-blood-oxygen.vue?vue&type=script&lang=js"
export * from "./section-blood-oxygen.vue?vue&type=script&lang=js"
import style0 from "./section-blood-oxygen.vue?vue&type=style&index=0&id=6dfbeb53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfbeb53",
  null
  
)

export default component.exports